import React, { useState, useEffect } from 'react'
import { Dialog, IconButton, DialogTitle, DialogContent, Checkbox } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { Model } from '../../models/model'

export const DialogListaPermisos = ({ open, setOpen, user }) => {

    const [permisos, setPermisos] = useState([])

    const getPermisos = async (userId) => {

        const dataPermisos = await Model.getAll({
            url: `usuarios/permisos/${userId}`
        })

        setPermisos(dataPermisos)

    }

    const handleUpdate = async () => {

        await Model.update({
            url: `usuarios/permisos/update/${user.id}`,
            dataForm: { permisos: JSON.stringify(permisos) }
        })

    }

    const handleChangeChecked = (e, id) => {

        const { target } = e

        const newListPermisos = permisos.map(it => {
            if (it.id_permiso === id) {
                return {
                    ...it,
                    status: target.checked
                }
            }

            return it

        })

        setPermisos(newListPermisos)

    }

    useEffect(() => {
        getPermisos(user.id)
    }, [user.id])

    return (
        <Dialog
            className='dialogoContacs'
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            <DialogTitle id="scroll-dialog-title">
                Permisos para <span style={{ textTransform: 'capitalize' }}>{user?.nombre}</span>
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon style={{ color: '#78667E' }} />
                </IconButton>

                <div>
                    <button
                        className='btn p-btn-primary'
                        style={{ width: '150px', textTransform: 'none', marginTop: '10px' }}
                        onClick={handleUpdate}
                    >
                        Guardar cambios
                    </button>
                </div>

            </DialogTitle>

            <DialogContent>
                <div className="table-responsive">
                    <table className="table p-table-global">
                        <thead className='p-thead-global'>
                            <tr className="text-center p-tr-titles-global">
                                <th className='text-start'>Permiso</th>
                                <th className='text-center'>Módulo</th>
                                <th>Habilitado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {permisos?.map(item => (
                                <tr key={item.id_permiso} className='p-tr-body-global'>
                                    <td className="text-start" style={{ textTransform: 'uppercase' }}>
                                        {item.nombre || '---'}
                                    </td>
                                    <td className="text-center" style={{ textTransform: 'uppercase' }}>
                                        {item.modulo || '---'}
                                    </td>
                                    <td className="text-center">
                                        <Checkbox
                                            size="small"
                                            checked={item.status}
                                            onClick={(e) => handleChangeChecked(e, item.id_permiso)}
                                        />
                                    </td>
                                </tr>
                            ))
                            }
                        </tbody>
                    </table>
                </div>
            </DialogContent>

        </Dialog>
    )
}